import React, { useEffect, useState } from 'react';
import useAnnouncements, {
    Announcement,
    announcementTypeLabels,
} from '../hooks/useAnnouncements';
import { Button } from '@/src/shadComponents/ui/button';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Loading from '@/src/Common/components/Loading';
import moment from 'moment-timezone';
import { Badge } from '@/src/shadComponents/ui/badge';
import PageShell from '@/src/Common/components/PageShell';

export default function AnnouncementList() {
    const [announcements, setAnnouncements] = useState<Announcement[]>([]);
    const { listAnnouncements, isLoading, error } = useAnnouncements();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAnnouncements = async () => {
            const data = await listAnnouncements();
            setAnnouncements(data);
        };

        fetchAnnouncements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) {
        return (
            <div className="rounded-md bg-red-50 p-4 mt-4">
                <div className="text-sm text-red-700">{error}</div>
            </div>
        );
    }

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    const actions = (
        <Button
            onClick={() => navigate('/admin/announcements/new')}
        >
            <Plus className="size-4" />
            New Announcement
        </Button>
    );

    return (
        <PageShell
            title="Announcements"
            subtitle="Manage your announcements and releases"
            breadcrumbs={[{ label: 'Admin', href: '/admin/announcements' }, { label: 'Announcements' }]}
            actions={actions}
        >
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Title</TableHead>
                            <TableHead>Type</TableHead>
                            <TableHead>By</TableHead>
                            <TableHead>Created</TableHead>
                            <TableHead className="text-right">
                                Actions
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {announcements.map((announcement) => (
                            <TableRow key={announcement.id}>
                                <TableCell className="font-medium">
                                    {announcement.title}
                                </TableCell>
                                <TableCell>
                                    <Badge
                                        variant={
                                            announcement.type === 0
                                                ? 'default'
                                                : 'secondary'
                                        }
                                    >
                                        {
                                            announcementTypeLabels[
                                                announcement.type
                                            ]
                                        }
                                    </Badge>
                                </TableCell>
                                <TableCell>{announcement.by}</TableCell>
                                <TableCell>
                                    {moment(announcement.createdAt).format(
                                        'MM/DD/YYYY',
                                    )}
                                </TableCell>
                                <TableCell className="text-right">
                                    <Button
                                        variant="outline"
                                        onClick={() =>
                                            navigate(
                                                `/admin/announcements/${announcement.id}`,
                                            )
                                        }
                                    >
                                        View
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
        </PageShell>
    );
}
